import { gql } from "@apollo/client";
import client from "../apolloClient";
import {
  PlaylistTag,
  PlaylistTagRequest,
  PlaylistTagFilters,
  PlaylistTagsResponse,
  UpdatePlaylistTagPayload,
} from "../../schemas/playlistTagSchema";

const GET_PLAYLIST_TAGS = gql`
  query GetPlaylistTags($page: Int, $pageSize: Int, $search: String) {
    playlistTags(page: $page, pageSize: $pageSize, search: $search) {
      playlistTags {
        id
        name
        description
        tenantId
        createdBy
        createdAt
        updatedAt
      }
      page
      pageSize
      total
      totalPages
      hasNextPage
      hasPrevPage
    }
  }
`;

const GET_PLAYLIST_TAG_BY_ID = gql`
  query GetPlaylistTagById($id: ID!) {
    playlistTag(id: $id) {
      id
      name
      description
      tenantId
      createdBy
      createdAt
      updatedAt
    }
  }
`;

const CREATE_PLAYLIST_TAG = gql`
  mutation CreatePlaylistTag($input: CreatePlaylistTagInput!) {
    createPlaylistTag(input: $input)
  }
`;

const UPDATE_PLAYLIST_TAG = gql`
  mutation UpdatePlaylistTag($id: ID!, $input: UpdatePlaylistTagInput!) {
    updatePlaylistTag(id: $id, input: $input)
  }
`;

const DELETE_PLAYLIST_TAGS = gql`
  mutation DeletePlaylistTags($ids: [ID!]!) {
    deletePlaylistTags(ids: $ids)
  }
`;

export const playlistTagService = {
  getAll: async (
    filters: PlaylistTagFilters = {},
  ): Promise<PlaylistTagsResponse> => {
    const { data } = await client.query({
      query: GET_PLAYLIST_TAGS,
      variables: filters,
      fetchPolicy: "network-only",
    });
    return data.playlistTags;
  },

  getById: async (id: string): Promise<PlaylistTag> => {
    const { data } = await client.query({
      query: GET_PLAYLIST_TAG_BY_ID,
      variables: { id },
      fetchPolicy: "network-only",
    });
    return data.playlistTag;
  },

  create: async (input: PlaylistTagRequest): Promise<boolean> => {
    const { data } = await client.mutate({
      mutation: CREATE_PLAYLIST_TAG,
      variables: { input },
    });
    return data.createPlaylistTag;
  },

  update: async (payload: UpdatePlaylistTagPayload): Promise<boolean> => {
    const { data } = await client.mutate({
      mutation: UPDATE_PLAYLIST_TAG,
      variables: {
        id: payload.id,
        input: payload.playlistTag,
      },
    });
    return data.updatePlaylistTag;
  },

  remove: async (ids: string[]): Promise<boolean> => {
    const { data } = await client.mutate({
      mutation: DELETE_PLAYLIST_TAGS,
      variables: { ids },
    });
    return data.deletePlaylistTags;
  },
};
